import React from 'react';
import ICommonFormProps from "../../yoello-lib/modules/dynamicForms/interfaces/ICommonFormProps";
import { FormPriceFieldTextAlongside } from "../../yoello-lib/modules/dynamicForms/CustomFormComponents/FormPriceFieldText";

const MinumunOrderValue = (props: ICommonFormProps) => {

  return (
    <div>
      <FormPriceFieldTextAlongside { ...props } displaySymbol />
    </div>
  )
}

export default MinumunOrderValue;
